export default __webpack_public_path__ + "static/media/khabib.875b3112.jpg";